import { render, staticRenderFns } from "./PageBalanceCharge.vue?vue&type=template&id=4274503f&scoped=true"
import script from "./PageBalanceCharge.vue?vue&type=script&lang=js"
export * from "./PageBalanceCharge.vue?vue&type=script&lang=js"
import style0 from "./PageBalanceCharge.vue?vue&type=style&index=0&id=4274503f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4274503f",
  null
  
)

export default component.exports